export default {
    state: {
        card: localStorage.getItem('card') === '0' || localStorage.getItem('card') === 0 ? 0 : localStorage.getItem('card'),
    },
    mutations: {
        setCard(state, card) {
            state.card = card;
        }  
    },
    actions: {
        setCard({commit}, card) {
            localStorage.setItem('card', card)
            commit('setCard', card);
        }
    },
};